import debounce from 'debounce';
import { useMemo } from 'react';

type Params = {
  interval?: number;
  immediate?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounced = <A extends (...args: any) => ReturnType<A>>(
  func: A,
  { interval = 0, immediate = false }: Params,
) => useMemo(() => debounce(func, interval, { immediate }), [interval, immediate, func]);
